import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { PortfolioCard } from "shared/ui/portfolio-card/PortfolioCard"

export function ProductCategoryCard({
  productCategory
}: {
  productCategory: ProductCategoryObj
}) {
  return (
    <PortfolioCard className="portfolio-card--category card--elevated">
      <PortfolioCard.Body>
        <PortfolioCard.Image>
          <Icon
            name={productCategory?.get("icon") as IconName}
            size={IconSize.FLEX}
          />
        </PortfolioCard.Image>
        <PortfolioCard.Title>
          {productCategory?.get("title")}
        </PortfolioCard.Title>
      </PortfolioCard.Body>
    </PortfolioCard>
  )
}
